module.exports = "/img/_/_/_/assets/images//arrows.png?bdd8704fcaf592dadaef3126e209e4df";